import { render, staticRenderFns } from "./settingWorkTypesCategory.vue?vue&type=template&id=3d2244f4&"
import script from "./settingWorkTypesCategory.vue?vue&type=script&lang=js&"
export * from "./settingWorkTypesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports